module.exports = __webpack_public_path__ + "static/media/canecaverde.4ef21854.jpg";